module.exports = __webpack_public_path__ + "img/mixtas.cbeb847f.png";